  <template>
    <v-navigation-drawer
    v-model="show"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    right
    >
        <v-list
        subheader
        flat
        >
        <v-subheader>Search by Name/Address/Phone</v-subheader>
            <v-list-item>
                <v-list-item-content class="pa-0">
                    <v-text-field
                        v-model="keyword"
                        light
                        label="Type Name/Address"
                        @keyup.enter.native="submitSearch"
                        clearable
                        hide-details
                        >
 
                    </v-text-field>
                    <v-text-field
                        v-model="phone"
                        light
                        label="Type Phone Number"
                        @keyup.enter.native="submitSearch"
                        clearable
                        hide-details
                        >
 
                    </v-text-field>            
                    <v-btn
                        depressed 
                        tile
                        color="primary"
                        class="mx-0 mb-0 mt-2"
                        @click.prevent="submitSearch">
                    
                        <v-icon>mdi-magnify</v-icon>
                        Search
                    </v-btn>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['show', 'filter', 'routekey'],
  data: () => ({
    keyword: "",
    phone: "",
    status: "",
  }),
  computed: {
    ...mapGetters({
        statuses: 'data/jobStatusArray',
    }),
    filteredStatuses() {
        return this.statuses.filter(status => {
            return status.value == 'active' || status.value == 'archived'
        })
    },
  },
  created() {
      this.keyword = this.filter.keyword
      this.phone = this.filter.phone
      this.status = this.filter.status
  },
  watch: {
    show(newVal) { // watch it
        this.$emit('update-drawer', newVal)
    },
    keyword(newVal) {
        this.$emit('update-keyword', newVal)
    },
    phone(newVal) {
        this.$emit('update-phone', newVal)
    },
    status(newVal) { // watch it
        this.$emit('update-status', newVal)
    },
  },
  methods: {
    submitSearch() {
        this.$emit('submit-search')
    }
  }
}
</script>